export function getRowsPerPagePref(tableId: string, fallback: number = 25): number {
  try {
    if (typeof window === 'undefined') return fallback;
    const key = `table_prefs_${tableId}`;
    const raw = window.localStorage.getItem(key);
    if (!raw) return fallback;
    const prefs = JSON.parse(raw);
    const candidate = prefs?.rowsPerPage ?? prefs?.rows_per_page;
    const n = Number(candidate);
    return Number.isFinite(n) && n > 0 ? n : fallback;
  } catch {
    return fallback;
  }
}

export function setRowsPerPagePref(tableId: string, value: number): void {
  try {
    if (typeof window === 'undefined') return;
    const key = `table_prefs_${tableId}`;
    const raw = window.localStorage.getItem(key);
    const prefs = raw ? JSON.parse(raw) : {};
    prefs.rowsPerPage = value;
    window.localStorage.setItem(key, JSON.stringify(prefs));
  } catch {
    // ignore write errors
  }
}
